export const ADDON_PREFIX = 'addon-';
export const AddonMode = {
    NORMAL: 'normal',
    IFRAME: 'iframe',
} as const;

export type AddonMode = typeof AddonMode[keyof typeof AddonMode];
